import React, { useState } from 'react';
import './Services.css';

const Services = () => {
  const [selectedService, setSelectedService] = useState(null);

  const services = [
    {
      icon: '🏠',
      title: 'Asistencia al Hogar',
      description: 'Servicios de mantenimiento, reparaciones menores, limpieza y cuidado del hogar las 24 horas.',
      features: ['Plomería básica', 'Electricidad menor', 'Cerrajería', 'Limpieza especializada'],
      coverage: [
        { service: 'Envío y pago de plomero por emergencia', cost: '$71.000', events: '12 eventos al año' },
        { service: 'Envío y pago de cerrajero por emergencia', cost: '$71.000', events: '12 eventos al año' },
        { service: 'Envío y pago de gasista por emergencia', cost: '$71.000', events: '12 eventos al año' },
        { service: 'Envío y pago de electricista por emergencia', cost: '$71.000', events: '12 eventos al año' },
        { service: 'Envío y pago de vidriero por emergencia', cost: '$71.000', events: '12 eventos al año' },
        { service: 'Traslado y guarda de muebles por inhabitabilidad', cost: '$90.000', events: '1 evento al año' },
        { service: 'Seguridad y vigilancia en caso de siniestro', cost: '$90.000', events: '1 evento al año' },
        { service: 'Traslado médico terrestre por accidente dentro de la vivienda', cost: 'Sin límite', events: 'Sin límite' }
      ],
      maintenanceCoverage: [
        { service: 'Reparación de electrodomésticos (todas las líneas)', cost: '$71.000', events: '3 eventos al año' },
        { service: 'Instalación de grifos y apliques en baños', cost: 'Instalación sin cargo', events: '1 evento al año' },
        { service: 'Destapaciones de cañerías y filtraciones de humedad', cost: '$59.000', events: '1 evento al año' },
        { service: 'Instalación de electrodomésticos (todas las líneas)', cost: '$71.000', events: '1 evento al año' },
        { service: 'Instalación de lámparas y apliques', cost: 'Instalación sin cargo', events: '1 evento al año' },
        { service: 'Trabajos de fumigación', cost: '$51.000', events: '1 evento al año' },
        { service: 'Cambio de persianas e instalación de cortinas', cost: '$51.000', events: '1 evento al año' },
        { service: 'Trabajos generales de carpintería, herrería y albañilería', cost: 'Presupuesto sin cargo', events: '12 eventos al año' },
        { service: 'Mantenimiento preventivo electrodomésticos (todas las líneas)', cost: '$51.000', events: '1 evento al año' }
      ]
    },
    {
      icon: '🐕',
      title: 'Asistencia Mascotas',
      description: 'Cuidado profesional para tus mascotas con veterinarios certificados y cuidadores especializados.',
      features: ['Consultas veterinarias', 'Cuidado temporal', 'Paseos y ejercicio', 'Emergencias 24/7'],
      coverage: [
        { service: 'Atención en centro veterinario', cost: '$31.000', events: '6 eventos al año' },
        { service: 'Phono vet', cost: 'Sin límite', events: '12 eventos al año' },
        { service: 'Paseo de perros en caso de hospitalización del afiliado', cost: '4 días por evento', events: '3 eventos al año' },
        { service: 'Hotel para mascotas en caso de hospitalización del afiliado', cost: '4 días por evento', events: '3 eventos al año' },
        { service: 'Descuento del 50% en medicamentos e inyectables derivados de la consulta', cost: '$12.000', events: '12 eventos al año' },
        { service: 'Servicio fúnebre de mascota', cost: '$71.000', events: '1 evento al año' },
        { service: 'Cirugías e internación', cost: '$71.000', events: '3 eventos al año' },
        { service: 'Análisis clínicos, imágenes, laboratorio', cost: '$37.000', events: '6 eventos al año' },
        { service: 'Descuento 50% en calendario de vacunación y desparasitado', cost: '$12.000', events: '6 eventos al año' }
      ]
    },
    {
      icon: '⚕️',
      title: 'Asistencia Salud',
      description: 'Servicios médicos domiciliarios y acompañamiento profesional para tu bienestar.',
      features: ['Consultas a domicilio', 'Enfermería', 'Fisioterapia', 'Acompañamiento médico'],
      coverage: [
        { service: 'Acompañante nocturno por internación', cost: '$54.000', events: '6 eventos al año' },
        { service: 'Médico a domicilio', cost: '$55.000', events: '3 eventos al año' },
        { service: 'Envío de enfermera a domicilio para colocación de inyecciones', cost: '$55.000', events: '6 eventos al año' },
        { service: 'Descuento en farmacias por medicamentos recetados (40%)', cost: '$22.000', events: '12 eventos al año' },
        { service: 'Phono med 24hs', cost: 'Sin límite', events: '12 eventos al año' },
        { service: 'Descuento del 50% en lentes recetados (no incluye marcos)', cost: '$12.000', events: '3 eventos al año' },
        { service: 'Consulta con nutricionista online', cost: '45 min', events: '12 eventos al año' },
        { service: 'Empleada doméstica en caso de internación', cost: '$44.000', events: '3 eventos al año' },
        { service: 'Consulta con psicólogo online', cost: '60 min', events: '12 eventos al año' },
        { service: 'Descuento del 50% en ortopedia e internación domiciliaria', cost: '$24.000', events: '3 eventos al año' }
      ]
    },
    {
      icon: '🚗',
      title: 'Asistencia Movilidad',
      description: 'Servicios de transporte seguro y asistencia vehicular para tu tranquilidad en el camino.',
      features: ['Transporte médico', 'Asistencia vehicular', 'Grúa 24/7', 'Conductor designado'],
      coverage: [
        { service: 'Servicio de mecánica ligera ante emergencias (auto/moto)', cost: '$71.000', events: '3 eventos al año' },
        { service: 'Servicio de remolque o grúa por accidente o avería (auto/moto)', cost: '100 km', events: '3 eventos al año' },
        { service: 'Traslado a la gomería por cambios de llanta', cost: 'Sin límite', events: '1 evento al año' },
        { service: 'Mantenimiento preventivo de bicicleta', cost: '$37.000', events: '1 evento al año' },
        { service: 'Traslado de bicicleta por enfermedad ocasional o accidente', cost: '50 km', events: '1 evento al año' },
        { service: 'Traslado médico terrestre (ambulancia) ante accidente', cost: 'Sin límite', events: 'Sin límite' }
      ]
    },
    {
      icon: '💻',
      title: 'Asistencia Tecnológica',
      description: 'Soporte técnico especializado para todos tus dispositivos y sistemas tecnológicos.',
      features: ['Soporte remoto', 'Instalación software', 'Reparación equipos', 'Configuración redes'],
      coverage: [
        { service: 'Asistencia telefónica pc 24hs (todos los dispositivos tecnológicos)', cost: 'Sin Topes', events: '12 eventos anuales' },
        { service: 'Asistencia smartphone / tablet / notebook Servicio de pantalla protegida', cost: '$71.000', events: '1 evento al año' },
        { service: 'Servicio técnico equipos electrónicos', cost: '$71.000', events: '1 evento al año' }
      ]
    },
    {
      icon: '⚖️',
      title: 'Asistencia Legal, Contable y Financiera',
      description: 'Asesoramiento profesional en temas legales, contables y financieros para tu seguridad jurídica.',
      features: ['Consultas legales', 'Asesoría contable', 'Planificación financiera', 'Gestión documental'],
      coverage: [
        { service: 'Asesoría legal telefónica en caso de robo, accidente, laboral, civil, penal, comercial, familiar', cost: 'Sin Límite', events: '12 eventos al año' },
        { service: 'Phono contable financiero: préstamos, impuestos, créditos, refinanciación de deudas, inversiones', cost: 'Sin Límite', events: '12 eventos al año' },
        { service: 'Conexión con abogado por litigio civil, penal, comercial y laboral', cost: '$64.000', events: '3 eventos al año' }
      ]
    }
  ];

  const openPopup = (service) => {
    setSelectedService(service);
  };

  const closePopup = () => {
    setSelectedService(null);
  };

  return (
    <section id="servicios" className="services">
      <div className="container">
        <div className="services-header">
          <h2 className="section-title">Explora y conoce todas tus asistencias</h2>
          <p className="section-subtitle">
            Ofrecemos una amplia gama de asistencias especializadas para cubrir todas tus necesidades
          </p>
        </div>

        <div className="services-grid">
          {services.map((service, index) => (
            <div key={index} className="service-card fade-in-up" style={{ animationDelay: `${index * 0.1}s` }}>
              <div className="service-icon-wrapper">
                <span className="service-icon">{service.icon}</span>
              </div>
              <div className="service-content">
                <h3 className="service-title">{service.title}</h3>
                <p className="service-description">{service.description}</p>
                <ul className="service-features">
                  {service.features.map((feature, featureIndex) => (
                    <li key={featureIndex} className="service-feature">
                      <span className="feature-check">✓</span>
                      {feature}
                    </li>
                  ))}
                </ul>
                <button
                  className="btn btn-secondary service-btn"
                  onClick={() => openPopup(service)}
                >
                  Ver cobertura
                </button>
              </div>
            </div>
          ))}
        </div>

        <div className="services-cta">
          <div className="cta-cards">
            <div className="cta-card digital-card">
              <div className="cta-card-content">
                <h3>Agenda tu asistencia digital ahora</h3>
                <p className="cta-subtitle">
                  Solicita tu multiasistencia desde cualquier dispositivo de forma rápida, fácil y segura. Todo a unos pocos clics.
                </p>
                <a href='https://galicia.dspigs.com/' target="_blank" rel="noopener noreferrer" className="btn-link">
                  <button className="btn btn-primary btn-large">
                    Agendar Ahora
                  </button>
                </a>
              </div>
            </div>

            <div className="cta-card phone-card">
              <div className="cta-card-content">
                <h3>Centro de atención telefónica 24 hs:</h3>
                <p className="cta-subtitle">
                  Atención personalizada las 24 horas. Nuestros especialistas te brindan asesoramiento inmediato y gestionan tu solicitud al instante.
                </p>
                <div className="phone-numbers">
                  <a href="tel:08003330713" className="phone-link">0800 333 0713</a>
                  <span className="phone-separator">o</span>
                  <a href="tel:43246417" className="phone-link">4324 6417</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Popup Modal */}
      {selectedService && (
        <div className="popup-overlay" onClick={closePopup}>
          <div className="popup-content" onClick={(e) => e.stopPropagation()}>
            <div className="popup-header">
              <div className="popup-logo">
                <span className="popup-icon">{selectedService.icon}</span>
                <h2>Multiservicios</h2>
              </div>
              <button className="popup-close" onClick={closePopup}>×</button>
            </div>

            <div className="popup-body">
              <div className="coverage-section">
                <h3 className="coverage-title">{selectedService.title.toUpperCase()}</h3>
                <div className="coverage-table">
                  <div className="table-header">
                    <div className="header-cell service-header">{selectedService.title.toUpperCase()}</div>
                    <div className="header-cell">COBERTURA</div>
                    <div className="header-cell">EVENTOS</div>
                  </div>
                  {selectedService.coverage.map((item, index) => (
                    <div key={index} className="table-row">
                      <div className="table-cell service-cell">{item.service}</div>
                      <div className="table-cell cost-cell">{item.cost}</div>
                      <div className="table-cell events-cell">{item.events}</div>
                    </div>
                  ))}
                </div>

                {selectedService.maintenanceCoverage && (
                  <>
                    <div className="coverage-table maintenance-table">
                      <div className="table-header">
                        <div className="header-cell service-header">{selectedService.title.toUpperCase()} - MANTENIMIENTO</div>
                        <div className="header-cell">COBERTURA</div>
                        <div className="header-cell">EVENTOS</div>
                      </div>
                      {selectedService.maintenanceCoverage.map((item, index) => (
                        <div key={index} className="table-row">
                          <div className="table-cell service-cell">{item.service}</div>
                          <div className="table-cell cost-cell">{item.cost}</div>
                          <div className="table-cell events-cell">{item.events}</div>
                        </div>
                      ))}
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default Services;